export const PHN_OPTIONS = [
  'North Coast PHN',
  'Central East Sydney PHN',
  'South Eastern NSW PHN',
  'Hunter New England Central Coast PHN',
  'Western Sydney PHN',
  'Murrumbidgee PHN',
  'South Western Sydney PHN',
  'Western NSW PHN',
];
